import React from "react";
import { StyledProgressBar, StyledProgressBarCaption, StyledProgressBarFiller } from "../../dashboard.style";

const ProgressBar = ({ sessionsAnalyzed, maxSessions, type }) => {
  const sessionsLeft = sessionsAnalyzed < maxSessions ? maxSessions - sessionsAnalyzed : 0;
  let fillProgressBar = ((maxSessions - sessionsLeft) * 100) / maxSessions;
  if(isNaN(fillProgressBar)){
     fillProgressBar = 0;
  }
  return (
    <div>
      <StyledProgressBar type={type} value={fillProgressBar}>
        <StyledProgressBarFiller type={type} value={fillProgressBar} />
      </StyledProgressBar>
      <StyledProgressBarCaption>
        <p>{parseInt(sessionsAnalyzed).toLocaleString("en", { useGrouping: true })} Sessions Analyzed</p>

        <p>{parseInt(sessionsLeft).toLocaleString("en", { useGrouping: true })} Sessions Left</p>
      </StyledProgressBarCaption>
    </div>
  );
};
export default ProgressBar;
